export default "__VITE_ASSET__9c6d0935__"